import trlMutator from 'src/utils/state/trlMutator';

const mutators = [trlMutator];

export default function mutate(data, params = {}) {
    return mutators.reduce((data, mutator) => mutator(data, params), data);
}
